import React, { FC } from "react";
import styles from "./style.module.scss";
import { FixedPrice } from "types/prices";

interface Props {
  columnsFlexes: number[];
  data: FixedPrice;
}

export const PriceRowItems: FC<Props> = ({ data, columnsFlexes }) => {
  return (
    <>
      <div
        className={`${styles.cell} ${styles.cell__boltText}`}
        style={{ flex: columnsFlexes[0], fontWeight: 700 }}
      >
        {data.name}
      </div>
      <div style={{ flex: columnsFlexes[1] }}>{data.type}</div>
      <div style={{ flex: columnsFlexes[2] }}>{data.from.join(", ")}</div>
      <div style={{ flex: columnsFlexes[3] }}>{data.to.join(", ")}</div>
      <ul className={styles.priceCell} style={{ flex: columnsFlexes[4] }}>
        <li className={styles.priceCell_rowItem}>
          <span>Business Plus:</span>
          <span className={styles.priceCell_priceValue}>
            £{data.businessPlusPrice}
          </span>
        </li>
        <li className={styles.priceCell_rowItem}>
          <span>First-Class:</span>
          <span className={styles.priceCell_priceValue}>
            £{data.firstClassPrice}
          </span>
        </li>
        <li className={styles.priceCell_rowItem}>
          <span>Business XL:</span>
          <span className={styles.priceCell_priceValue}>
            £{data.businessXLPrice}
          </span>
        </li>
      </ul>
    </>
  );
};
